import React from 'react';
import { industrialMechanical as data, contact } from '../../content/site';
import { ArrowRight, Mail } from '../Common/Icons';

const AboutIndustrialMechanical = () => (
  <>
    <section className="section">
      <div className="container">
        <div className="detail__grid">
          <div className="detail__media reveal">
            <img
              src={data.image}
              alt="LIDA Engineering crew servicing a valve assembly in the fabrication yard"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="detail__body reveal" style={{ '--reveal-delay': '100ms' }}>
            <p className="eyebrow">Overview</p>
            <p className="detail__lead">{data.lead}</p>
            <p>
              Our disciplines span mechanical, structural, civil and chemical engineering,
              alongside the value engineering, cost analysis, procurement, claims and HSE
              expertise needed to keep a project moving.
            </p>

            <div className="detail__cta">
              <a href={`mailto:${contact.email}`} className="btn">
                Request a Quote
                <ArrowRight />
              </a>
              <a href="#contact" className="btn btn--outline">
                <Mail />
                Contact us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section section--paper2">
      <div className="container">
        <div className="section-head section-head--center">
          <p className="eyebrow">Disciplines</p>
          <h2>Engineering expertise across the project lifecycle.</h2>
        </div>

        <div className="disciplines">
          {data.disciplines.map((item) => (
            <article className="discipline" key={item.title}>
              <h3 className="discipline__title">{item.title}</h3>
              <p className="discipline__body">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default AboutIndustrialMechanical;
